import classnames from 'classnames2';
import React from 'react';

import { IHasTooltip, mapPropsToStyles } from '../Tooltip/Tooltip';
import TooltipStyles from '../Tooltip/Tooltip.scss';

import styles from './Button.scss';

export type IButtonColor = 'primary' | 'positive' | 'negative' | 'ghost' | 'no-color' | 'default';
export type IButtonSize = 'small' | 'tiny' | 'default';

export interface IButtonProps extends IHasTooltip, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  active?: boolean;
  disabled?: boolean;
  link?: boolean; // renders the button as an anchor element
  color?: IButtonColor;
  block?: boolean; // full width button
  size?: IButtonSize;
  unstyled?: boolean;
  type?: string; // the type of button 'submit' | 'reset' | 'button'
  'data-test'?: string;
}

export const Button: React.FC<IButtonProps> = props => {
  const {
    active,
    link,
    className,
    color = 'default',
    disabled,
    children,
    block,
    size = 'default',
    unstyled,
    tooltipText,
    tooltipPosition,
    tooltipVisible,
    type,
    ...rest
  } = props;
  const Tag: any = link ? 'a' : 'button';
  const buttonType = type ? type : link ? null : 'button';

  const colorClasses = {
    [styles.default]: color === 'default',
    [styles.primary]: color === 'primary',
    [styles.positive]: color === 'positive',
    [styles.negative]: color === 'negative',
    [styles.noColor]: color === 'no-color',
    [styles.ghost]: color === 'ghost'
  };

  // a size of 'default' means no addtional style applied
  const otherClasses = {
    [styles.block]: block,
    [styles.small]: size === 'small',
    [styles.tiny]: size === 'tiny',
    [styles.disabled]: disabled
  };

  const tooltipClasses = mapPropsToStyles(TooltipStyles, {
    tooltip: tooltipText,
    visible: tooltipVisible,
    position: tooltipPosition
  });

  return (
    <Tag
      className={classnames(
        styles.btn,
        unstyled ? styles.unstyled : colorClasses,
        otherClasses,
        tooltipClasses,
        active ? 'active' : '',
        className
      )}
      disabled={disabled}
      type={buttonType}
      aria-label={tooltipText}
      {...rest}
    >
      {children}
    </Tag>
  );
};

Button.defaultProps = {
  tooltipPosition: 'n'
};

export interface ICloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  inputMode?: 'none' | 'search' | 'numeric' | 'text' | 'email' | 'tel' | 'url' | 'decimal';
}

export const CloseButton: React.FC<ICloseButtonProps> = props => {
  const { className, ...rest } = props;

  return <button className={classnames(styles.close, className)} {...rest} />;
};
